import { createFileRoute, redirect } from "@tanstack/react-router";

import { RequireAnonymous } from "@/hooks/shared/CheckAuth";
import { can } from "@/constants/permissions";
import {
  consumeReturnTo,
  resolveSession,
  SessionUnavailableError,
} from "@/hooks/shared/session";

export const Route = createFileRoute("/_auth/_anonymous")({
  beforeLoad: async () => {
    try {
      const session = await resolveSession();

      if (!session) return;

      if (!can(session.user.role, "console.access")) {
        throw redirect({ to: "/mobile-only" });
      }

      throw redirect({ to: consumeReturnTo() });
    } catch (error) {
      /* Outage while probing — show the sign-in form; do not assume a session. */
      if (error instanceof SessionUnavailableError) return;
      throw error;
    }
  },
  component: RequireAnonymous,
});
